import { Injectable } from '@angular/core';

/**
 * PosConfigNavigationService (Angular 18)
 *
 * Ported 1:1 from apps/b2b-ui/common/services/posConfig/posConfigNavigation/posConfigNavigation.service.js
 * (legacy name 'PosConfigNavigationService'). Holds the POS header-button
 * navigation model and its default seed. Internal sub-service of
 * PosConfigService — injected directly, not downgrade-registered.
 * Dependency-free (`angular.forEach` → native iteration). Wave 3 #17.
 */
@Injectable({ providedIn: 'root' })
export class PosConfigNavigationService {
  model: any[] = [];

  init(): boolean {
    return true;
  }

  setModel(model: any): void {
    if (model && model instanceof Array) {
      model.forEach((item: any) => {
        if (!item.text.length) {
          item.text = item.name;
        }
      });

      this.model = model;
    } else {
      this.reset();
    }
  }

  getModel(): any[] {
    return this.model;
  }

  reset(): void {
    this.model = [
      {
        order: 0,
        type: 'retail',
        name: 'Retail',
        text: 'Retail',
        color: { r: 0, g: 176, b: 238, a: 1 },
        display: true,
      },
      {
        order: 1,
        type: 'members',
        name: 'Indv. Members',
        text: 'Indv. Members',
        color: { r: 0, g: 176, b: 238, a: 1 },
        display: true,
      },
      {
        order: 2,
        type: 'groups',
        name: 'Organizations',
        text: 'Organizations',
        color: { r: 0, g: 176, b: 238, a: 1 },
        display: true,
      },
      {
        order: 3,
        type: 'corporate',
        name: 'Org. Members',
        text: 'Org. Members',
        color: { r: 0, g: 176, b: 238, a: 1 },
        display: true,
      },
      {
        order: 4,
        type: 'customer',
        name: 'Customers',
        text: 'Customers',
        color: { r: 0, g: 176, b: 238, a: 1 },
        display: true,
      },
    ];
  }
}
